import { map as rxjsmap } from 'rxjs';


import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { ContractorContacts, SubContractor } from '../models/contractor';
import { BaseServices } from './../../kuba.services';
import { UserService } from './../../users/services/user.service';
import { User } from './../models/contractor';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SubContractorServices {
  constructor(
    private http: HttpClient,
    private userService: UserService
  ) {}

  // List all SubContractor
  list() {
    return this.http
      .get(environment.BASE_URL + '/contractor').pipe(rxjsmap(result => result));
  }

  getContractorByBusiness(businessId: any) {
    return this.http
      .get<any>(environment.BASE_URL + '/contractorsbybusiness/' + businessId).pipe(rxjsmap(result => result));
  }

  getProjectByUser(Id: number, businessId: number) {
    return this.http
      .get<any>(
        environment.BASE_URL +
          '/project/getuserprojects/' +
          Id +
          '/' +
          businessId +
          '/' +
          BaseServices.FeatureId
      ).pipe(rxjsmap(result => result));
  }

  get(id: number) {
    return this.http
      .get<any>(environment.BASE_URL + '/contractors/' + id).pipe(rxjsmap(result => result));
  }

  add(data: any) {
    return this.http
      .post(environment.BASE_URL + '/contractors', data).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  update(id: number, data: SubContractor) {
    return this.http
      .put(environment.BASE_URL + '/contractors/' + id, data).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  listContractorContact(contractorId: number) {
    return this.http
      .get(environment.BASE_URL + '/contractorcontacts/' + contractorId).pipe(rxjsmap(result => result));
  }

  addContractorContact(data: any) {
    return this.http
      .post(environment.BASE_URL + '/contractorcontact', data).pipe(rxjsmap(result => result));
  }

  updateContractorContact(data: any) {
    return this.http
      .put(environment.BASE_URL + '/contractorcontact', data).pipe(rxjsmap(result => result));
  }

  getContractorContact(id: any) {
    return this.http
      .get(environment.BASE_URL + '/contractorcontact/' + id).pipe(rxjsmap(result => result));
  }

  deleteContractorContact(id: any) {
    return this.http
      .delete(environment.BASE_URL + '/contractorcontact/' + id).pipe(rxjsmap(result => result));
  }

  statusUpdate(id: any, status: any) {
    return this.http
      .put(environment.BASE_URL + '/contractorstatusupdate/' + id, status).pipe(rxjsmap(result => result));
  }

  deleteMultipleContractor(ids: any) {
    return this.http
      .put(environment.BASE_URL + '/contractors', ids).pipe(rxjsmap(result => result));
  }

  getContractorContactUser(featureKey: number): Observable<User> {
    return this.http
      .get<any>(`${environment.BASE_URL}/contractorcontactuser/${featureKey}`).pipe(rxjsmap(result => result));
  }

  addUser(data: any) {
    return this.userService.addusers(data);
  }

  updateUser(data: any) {
    return this.userService.updateUser(data.Id, data);
  }

  getUserById(Id: any) {
    return this.userService.getUsersById(Id);
  }
}
